var triggers = document.querySelectorAll(".js-trigger-details");
for (var i = 0; i < triggers.length; i++) {
  triggers[i].addEventListener("click", function () {
    this.classList.toggle("details--open");
  });
}

const forgot_trigger = document.querySelector('.js-forgot')
const recover = document.querySelector('.js-recover')
const recover_close = document.querySelector('.js-recover-close')


if (forgot_trigger) {
  forgot_trigger.addEventListener('click', () => {
    recover.style.display = 'block'
  })
}

if (recover_close) {
  recover_close.addEventListener('click', () => {
    recover.style.display = 'none'
  })
}

// return_url attrribute for registration form
if (window.location.href.includes('return_url') && document.querySelector('.js-register')) {
  let register = document.querySelector('.js-register');
  let register_url = register.getAttribute('href') + '?' + window.location.href.slice((window.location.href.indexOf('return_url')));
  register.setAttribute('href', register_url);
}
